import { useState } from "react";
import MainLayout from "@/components/layout/MainLayout";
import ItineraryForm from "@/components/itinerary/ItineraryForm";
import ItineraryDisplay from "@/components/itinerary/ItineraryDisplay";
import NewsList from "@/components/news/NewsList";
import { NewsArticle, fetchNewsForCity } from "@/lib/news";

const Itinerary = () => {
  const [itinerary, setItinerary] = useState("");
  const [loading, setLoading] = useState(false);
  const [newsArticles, setNewsArticles] = useState<NewsArticle[]>([]);
  const [newsLoading, setNewsLoading] = useState(false);

  const handleItineraryGenerated = async (newItinerary: string, destination: string) => {
    setItinerary(newItinerary);
    
    // Fetch news for the destination
    setNewsLoading(true);
    try {
      const articles = await fetchNewsForCity(destination);
      setNewsArticles(articles);
    } catch (error) {
      console.error('Error fetching news:', error);
    } finally {
      setNewsLoading(false);
    }
  };
  
  return (
    <MainLayout>
      <div className="travel-container py-12">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold mb-2">Itinerary Generator</h1>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Create a personalized day-by-day travel plan based on your destination, duration, and interests.
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div>
            <ItineraryForm 
              onItineraryGenerated={handleItineraryGenerated} 
              setLoading={setLoading}
              itinerary={itinerary}
            />
          </div>
          
          <div className="space-y-6">
            <div className={`h-[600px] ${loading ? 'animate-pulse' : ''}`}>
              {loading ? (
                <div className="search-card h-full flex flex-col items-center justify-center">
                  <div className="w-10 h-10 border-4 border-travel-blue border-t-transparent rounded-full animate-spin mb-4"></div>
                  <p className="text-gray-500">Generating your personalized itinerary...</p>
                  <p className="text-xs text-gray-400 mt-2">This may take up to 30 seconds</p>
                </div>
              ) : (
                <ItineraryDisplay itinerary={itinerary} />
              )}
            </div>
            
            <NewsList articles={newsArticles} isLoading={newsLoading} />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default Itinerary;
